import React from 'react';

import {
  IconButton,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  styled,
  CloseIcon,
  RemoveCircleOutlineIcon,
} from '@gogame/components';
import { FormField } from '@gogame/form';

import { AGENCY, BUDGET, MEDIA_SOURCE } from '../constants';

const TopCell = styled(TableCell)`
  vertical-align: top;
`;

export const AppsFlyerAgencies = ({
  agencies,
  onRemove,
  onRemoveAll,
  options,
}) => {
  const handleMediaSourceValidation = (value) => {
    if (!value) {
      return 'Media source name is required';
    }
  };
  return agencies?.length ? (
    <TableContainer>
      <Table size={'small'}>
        <TableHead>
          <TableRow>
            <TableCell col={'agency'} size={'medium'}>
              Name
            </TableCell>
            <TableCell col={'budget'} size={'medium'} width={136}>
              Budget *
            </TableCell>
            <TableCell col={'source'} size={'medium'} width={336}>
              Media Source Name *
            </TableCell>
            <TableCell
              col={'actions'}
              size={'medium'}
              width={64}
              padding={'actions'}
            >
              <IconButton
                icon={<CloseIcon />}
                tooltip={'Remove all'}
                onClick={onRemoveAll}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {agencies?.map((_agency, i) => (
            <TableRow key={`agency_${i}`}>
              <TopCell col={'agency'}>
                <FormField.Const
                  name={`[${i}]${AGENCY}`}
                  options={options}
                  padding={0}
                  lazy={true}
                />
              </TopCell>
              <TopCell col={'budget'}>
                <FormField.TextField
                  type={'currency'}
                  name={`[${i}]${BUDGET}`}
                  placeholder={'$0'}
                  padding={0}
                />
              </TopCell>
              <TopCell col={'source'}>
                <FormField.TextField
                  name={`[${i}]${MEDIA_SOURCE}`}
                  placeholder={'Media source name'}
                  padding={0}
                  validate={handleMediaSourceValidation}
                />
              </TopCell>
              <TableCell col={'actions'} padding={'actions'}>
                <IconButton
                  icon={<RemoveCircleOutlineIcon />}
                  tooltip={'Remove'}
                  onClick={() => onRemove(i)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : null;
};
